/**
 * @description Use this to place text over an element
 * @param {string} csDescriptor - a string bound via two-way binding, used as the descriptor (similar to a placeholder)
 * @example
 * <div cs-descriptor="ctrl.minLengthInputDescription">
 *   <input type="number" class="form-control" name="minLength" id="minLength" required ng-min="ctrl.restrictions.min_size" ng-max="ctrl.restrictions.max_size" ng-model="ctrl.policy.minLength">
 * </div>
 */
;(function () {
  'use strict'

  angular.module('contrast.form').directive('csDescriptor', function () {
    return {
      replace: true,
      restrict: 'A',
      transclude: true,
      templateUrl: 'components/form/cs-descriptor.html',
      scope: {
        csDescriptor: '='
      },
      link: function ($scope, elem) {
        var parent = elem.parent()
        var c = 'cs-descriptor-container-small'
        var display = true
        $scope.determineTooltip = function () {
          if (!display) {
            return $scope.csDescriptor
          }
          return undefined
        }
        $scope.$watch(
          function () {
            return parent.width()
          },
          function () {
            if (parent.width() <= 100) {
              elem.addClass(c)
              display = false
            } else {
              elem.removeClass(c)
              display = true
            }
          }
        )
      }
    }
  })
})()
